import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import React from 'react';
import classnames from 'clsx';
import { testId } from 'ui-components/services/testid-service';
import style from './fancy-state-icon.module.css';

import { ErrorWarningInfoPropType } from '../../prop-types/error-warning-info';

const exclamationCircleSolidIcon = (props) => <FontAwesomeIcon {...props} icon={faExclamationCircle} />;
const exclamationTriangleSolidIcon = (props) => <FontAwesomeIcon {...props} icon={faExclamationTriangle} />;
const informationCircleSolidIcon = (props) => <FontAwesomeIcon {...props} icon={faInfoCircle} />;

const stateToDisplayInformationMap = {
  error: {
    stateClassName: style['error-icon'],
    SvgIcon: exclamationCircleSolidIcon,
    useTriangle: false,
  },
  warning: {
    stateClassName: style['warning-icon'],
    SvgIcon: exclamationTriangleSolidIcon,
    useTriangle: true,
  },
  info: {
    stateClassName: style['info-icon'],
    SvgIcon: informationCircleSolidIcon,
    useTriangle: false,
  },
};

export const FancyStateIcon = ({ state }) => {
  const displayInformation = stateToDisplayInformationMap[state] || stateToDisplayInformationMap.error;
  const { stateClassName, SvgIcon, useTriangle } = displayInformation;
  const classes = classnames(style['fancy-state-icon'], stateClassName);
  return (
    <div className={classes} {...testId('fancy-state-icon')}>
      {useTriangle && <div className={style.triangle} />}
      <SvgIcon />
    </div>
  );
};

FancyStateIcon.propTypes = {
  state: ErrorWarningInfoPropType.isRequired,
};
